import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Profile from 'containers/Student/Materials/Profile';

const Materials = () => {
	return (
		<Switch>
			<Route path="/materials/:id(\d+)">
				<Profile />
			</Route>
		</Switch>
	);
};

export default Materials;